// extracted by mini-css-extract-plugin
export default {"footer_social":"FooterSocial_footer_social__OiHyJ","footer_brand_icon":"FooterSocial_footer_brand_icon__AcpK5","footer_pay_icon":"FooterSocial_footer_pay_icon__23lJi"};